/**
 * ヤギプライム解約ページ（/yagiprimecancel）は、解約できる契約がある会員だけに開く。
 *
 * 契約が無い会員（未加入・期限切れ・決済失敗で停止中）でもページが開けたため、
 * 解約 API が 404 を返して「解約失敗」として記録されていた。ページ内の加入判定は
 * FIREBASE_INITIALIZED 購読に頼っており、ルート表示より先に発火すると走らない。
 * そのためルートに入る前に判定する。
 *
 * - 未ログインは route meta の requiresAuth（beforeEach）で先にログインへ送られる
 * - 未加入（404 を含む）→ /mypage、解約予約済み → /mypage/account
 * - 判定できなかったとき（タイムアウト・5xx）は加入者を締め出さないよう通す
 */
import type { NavigationGuard } from 'vue-router'
import { useAuth } from '@/composables/useAuth'
import { fetchIsSubscribed } from '@/services/yagiprime/prime-membership-client'

export const yagiprimeCancelGuard: NavigationGuard = async (
  _to,
  _from,
  next
) => {
  const user = await useAuth().whenAuthReady()
  if (!user) {
    next()
    return
  }
  const status = await fetchIsSubscribed(user.uid)
  if (status && (!status.is_subscribed || status.is_cancel)) {
    // 遷移先のマイページ系は FIREBASE_INITIALIZED で初期化するため、
    // SPA 遷移ではなく既存どおり実 URL で移る
    window.location.replace(
      status.is_subscribed ? '/mypage/account' : '/mypage'
    )
    next(false)
    return
  }
  next()
}
